/**
 * @generated SignedSource<<cc7bef3ac38623143e6315275cdb08f3>>
 * @relayHash 476f2c1dd991f85c477f2872cbf7f1b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 40882173ae89bd7507e9083f86d4529188c5c66189604b6b508e16170b0955fb

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ClassicProjectFieldsAppQuery$variables = {
  cloudId: string;
};
export type ClassicProjectFieldsAppQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"ClassicProjectFieldsPage">;
  };
};
export type ClassicProjectFieldsAppQuery = {
  response: ClassicProjectFieldsAppQuery$data;
  variables: ClassicProjectFieldsAppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ClassicProjectFieldsAppQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "ClassicProjectFieldsPage"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClassicProjectFieldsAppQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              }
            ],
            "concreteType": "JiraHomePage",
            "kind": "LinkedField",
            "name": "userHomePage",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "link"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "40882173ae89bd7507e9083f86d4529188c5c66189604b6b508e16170b0955fb",
    "metadata": {},
    "name": "ClassicProjectFieldsAppQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "86a8400c7057fd20d584903fa1f6181f";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
